/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export enum EvaluationStatus {
  SUCCEEDED = "SUCCEEDED",
  IN_PROGRESS = "IN_PROGRESS",
  WAITING = "WAITING",
  FAILED = "FAILED",
}
